module.exports = __webpack_public_path__ + "static/media/voice-2.7905ace1.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/voice-2.png
// module id = 631
// module chunks = 0